export function shareOnWhatsApp(text: string, url: string) {
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`;
  window.open(whatsappUrl, '_blank');
}

export function shareOnInstagram(text: string, url: string) {
  navigator.clipboard.writeText(text + ' ' + url);
}

export function shareOnEmail(subject: string, body: string, url?: string) {
  const fullBody = url ? `${body}\n\n${url}` : body;
  const mailtoUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(fullBody)}`;
  window.open(mailtoUrl, '_blank');
}

export function copyToClipboard(text: string) {
  navigator.clipboard.writeText(text);
}
